import type { IPresetTheme } from "@/types"
import { PresetTheme } from "@/types"

export const defaultTheme: IPresetTheme = {
  label: "Default",
  value: PresetTheme.Default,
  colors: {
    headerBackground: "#E4D2BE",
    footerBackground: "#ddd",
    primaryColour: "#072A47",
    secondaryColour: "#E4D2BE",
    linkText: "#072A47",
    navText: "#072A47",
    primaryButtonText: "#E4D2BE",
    secondaryButtonText: "#072A47",
    borders: "none",
    primaryCardText: "#E4D2BE",
    secondaryCardText: "#072A47",
  },
  fonts: {
    headingFont: "Comfortaa",
    baseFont: "Montserrat",
  },
}
